import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

// Audit phase 6 (ruling 2): the dashboard held only the old event and error
// log charts. Old URLs and bookmarks land on their replacements; the error
// log is the Errors page (error tracking, D7).
const ERRORS = '/admin/errors'

export const LayoutDashboard = () => (
  <Switch>
    <Route path="/admin/dashboard/log-error"><Redirect to={ERRORS} /></Route>
    <Route path="/admin/dashboard"><Redirect to="/admin/audit-log" /></Route>
  </Switch>
)
